import { render, staticRenderFns } from "./AdminDetails.vue?vue&type=template&id=090af055&scoped=true&"
import script from "./admin-details.ts?vue&type=script&lang=ts&"
export * from "./admin-details.ts?vue&type=script&lang=ts&"
import style0 from "./admin-details.scss?vue&type=style&index=0&id=090af055&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "090af055",
  null
  
)

export default component.exports